import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src", "alt"];
import { computed } from "vue";
import frFlag from "flag-icons/flags/4x3/fr.svg";
import caFlag from "flag-icons/flags/4x3/ca.svg";
import gbFlag from "flag-icons/flags/4x3/gb.svg";
import nlFlag from "flag-icons/flags/4x3/nl.svg";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FlagIcon',
    props: {
        country: {}
    },
    setup(__props) {
        const props = __props;
        const flagMap = {
            fr: frFlag,
            ca: caFlag,
            gb: gbFlag,
            nl: nlFlag,
        };
        const flagSrc = computed(() => flagMap[props.country] ?? "");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("img", {
                src: flagSrc.value,
                alt: `${__props.country} flag`,
                class: "flag-icon"
            }, null, 8 /* PROPS */, _hoisted_1));
        };
    }
});
